var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('event-header', {
    attrs: {
      "event": _vm.getEvent
    }
  }), _c('b-row', {
    attrs: {
      "align-v": "stretch"
    }
  }, [_c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "sm": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('locations')], 1), _c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "sm": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('responsibles')], 1), _c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "sm": "12",
      "md": "6",
      "offset-md": "3",
      "lg": "4",
      "offset-lg": "0"
    }
  }, [_c('topics')], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }